module.exports = __webpack_public_path__ + "static/media/arrow_left.1082fd4f.svg";